export class AccDocumentsResultDto {
  source: string;
  fileName: string;
  fileUrl: string;
}
